var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card white"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.card.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }